import React from 'react';
import { Card, Button, Form, Input, Row, Col } from 'antd';

const Connection = ({ connect, disconnect, connectBtn }) => {
  const [form] = Form.useForm();
  const record = {
    protocol: "wss",
    host: 'boxdin.ddns.net',
    clientId: `mqttjs_ + ${Math.random().toString(16).substr(2, 8)}`,
        port: 15676,
        path: "/ws",
  };
  const onFinish = (values) => {
    console.log("values");
    console.log(values);
    const { protocol, host, clientId, port, path, username, password } = values;
    const url = `ws://${host}:${port}/ws`;
    const options = {
      protocol: "ws",
      path: '/ws',
      keepalive: 30,
      protocolVersion: 4,
      clean: true,
      reconnectPeriod: 1000,
      connectTimeout: 30 * 1000,
      will: {
        topic: 'WillMsg',
        payload: 'Connection Closed abnormally..!',
        qos: 0,
        retain: false
      },
      rejectUnauthorized: false
    };
    options.protocol = protocol;
    options.clientId = clientId;
    options.username = username;
    options.password = password;
    options.path = path;
    connect(url, options);
  };

  const handleConnect = () => {
    form.submit();
  };

  const handleDisconnect = () => {
    disconnect();
  };

  const ConnectionForm = (
    <Form
      layout="vertical"
      name="basic"
      form={form}
      initialValues={record}
      onFinish={onFinish}
    >
      <Row gutter={6}>
      <Col span={5}>
          <Form.Item
            label="Protocol"
            name="protocol"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item
            label="Host"
            name="host"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item
            label="Port"
            name="port"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item
            label="Path"
            name="path"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Client ID"
            name="clientId"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Username"
            name="username"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Password"
            name="password"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )

  return (
    <Card
      size="small"
      title="Connection"
      actions={[
        <Button type="primary" onClick={handleConnect}>{connectBtn}</Button>,
        <Button danger onClick={handleDisconnect}>Disconnect</Button>
      ]}
    >
      {ConnectionForm}
    </Card>
  );
}

export default Connection;
